import { Permission } from "./userPermission";

export default new Permission()